exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ImageUploader {\n  width: 300px;\n}\n.ImageUploader .fileContainer {\n  padding: 10px;\n  box-sizing: border-box;\n}\n", ""]);

